import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  discountAdd,
  discountUpdate,
  getDiscountDetail,
} from "../../services/discountService";
import SuccessAlert from "../../components/child/Alert/SuccessAlert";
import DengerAlert from "../../components/child/Alert/DengerAlert";
import Loader from "../../components/child/Loder";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const DiscountFormPage = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // for edit mode
  const isEditMode = !!id;

  const [code, setCode] = useState("");
  const [desc, setDesc] = useState("");
  const [discount, setDisc] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [errors, setErrors] = useState({});

  // ✅ Fetch category for edit mode
  useEffect(() => {
    if (isEditMode) {
      const fetchData = async () => {
        setLoading(true);
        try {
          const res = await getDiscountDetail(id);
          const data  = res.data.result;
          console.log(data);
          setCode(data.code || "");
          setDesc(data.description || "");
          setDisc(data.discount || "");
          setStartDate(data.startDate || "");
          setEndDate(data.endDate || "");
        } catch (err) {
          setErrorMessage("Failed to fetch discount detail.");
        } finally {
          setLoading(false);
        }
      };
      fetchData();
    }
  }, [id]);

  const clearMessage = () => {
    setTimeout(() => {
      setSuccessMessage("");
      setErrorMessage("");
    }, 3000);
  };

const validateInputs = () => {
  const newErrors = {};

  if (!code) {
    newErrors.code = "PromoCode is required.";
  }
  if (!desc) {
    newErrors.desc = "Description is required.";
  }
if (!discount) {
    newErrors.discount = "Discount is required.";
  } else if (parseFloat(discount) > 100) {
    newErrors.discount = "Invalid discount. Must be 100 or less.";
  }
  if (!startDate) {
    newErrors.startDate = "Start Date is required.";
  }
  if (!endDate) {
    newErrors.endDate = "End Date is required.";
  }
  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

  const handleSubmit = async (e) => {

    e.preventDefault();
    if (!validateInputs()) return;

    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");

    try {
      let response;

      if (isEditMode) {
        response = await discountUpdate(id, { code , desc, discount , startDate , endDate });
      } else {
        response = await discountAdd({ code , description:desc, discount , startDate , endDate });
      }
      const successMsg =
        response?.data?.message ||
        response?.data?.data?.message ||
        (isEditMode
          ? "Discount updated successfully!"
          : "Discount added successfully!");

      setSuccessMessage(successMsg);
      setTimeout(() => {
        navigate("/discount");
      }, 1000);
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        (isEditMode ? "Failed to update discount." : "Failed to add discount.");
      setErrorMessage(msg);
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="row gy-4">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            {successMessage && <SuccessAlert message={successMessage} />}
            {errorMessage && <DengerAlert message={errorMessage} />}
            <form
              className="row gy-3 needs-validation"
              noValidate
              onSubmit={handleSubmit}
            >
              <div className="col-md-12">
                <label className="form-label">
                  Code<span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.code ? "is-invalid" : ""}`}
                  placeholder="Enter code"
                  value={code}
                  maxLength={10}
                  onChange={(e) => {
                    const val = e.target.value;

                    // Allow only alphabets and single spaces
                    const filtered = val
                      .replace(/[^A-Za-z0-9\s]/g, "") // ✅ allows letters, digits, spaces
                      .replace(/\s{2,}/g, " ");
                    setCode(filtered);
                    setErrors((prev) => ({ ...prev, code: "" }));
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/\s{2,}/g, " ") // Replace multiple spaces with a single space
                      .trimStart(); // Prevent leading spaces
                  }}
                />
                {errors.code && (
                  <div className="invalid-feedback">{errors.code}</div>
                )}
              </div>
              <div className="col-md-12">
                <label className="form-label">
                  Discount(%)<span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.discount ? "is-invalid" : ""
                  }`}
                  placeholder="Enter code"
                  value={discount}
                  maxLength={50}
                  onChange={(e) => {
                    const val = e.target.value;

                    // Allow only alphabets and single spaces
                    const filtered = val
                      .replace(/[^0-9]/g, "") // ✅ allows letters, digits, spaces
                      .replace(/\s{2,}/g, " ");
                    setDisc(filtered);
                    setErrors((prev) => ({ ...prev, discount: "" }));
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/\s{2,}/g, " ") // Replace multiple spaces with a single space
                      .trimStart(); // Prevent leading spaces
                  }}
                />
                {errors.discount && (
                  <div className="invalid-feedback">{errors.discount}</div>
                )}
              </div>
              
              <div className="col-md-12 d-flex" style={{gap:"10px"}}>
                <div className="col-md-6 d-grid">
                  <label className="form-label">
                    Start Date<span className="text-danger-600">*</span>
                  </label>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => {
                      setStartDate(date);
                      setEndDate(null); // reset endDate
                       setErrors((prev) => ({ ...prev, startDate: "" }));
                    }}
                    style={{maxWidth:"50%"}}
                    className={`form-control ${
                    errors.startDate ? "is-invalid" : ""
                  }`}
                    placeholderText="Start Date"
                    dateFormat="yyyy-MM-dd"
                  />
                  {errors.startDate && (
                    <div className="invalid-feedback d-block">{errors.startDate}</div>
                  )}
                </div>
                <div className="col-md-6 d-grid">
                  <label className="form-label">
                    End Date<span className="text-danger-600">*</span>
                  </label>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => {
                      setEndDate(date)
                      setErrors((prev) => ({ ...prev, endDate: "" }));
                    }}
                      style={{maxWidth:"50%"}}
                  className={`form-control ${
                    errors.endDate ? "is-invalid" : ""
                  }`}
                    placeholderText="End Date"
                    dateFormat="yyyy-MM-dd"
                    minDate={startDate}
                  />
                  {errors.endDate && (
                    <div className="invalid-feedback d-block">{errors.endDate}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <label className="form-label">
                 Description<span className="text-danger-600">*</span>
                </label>
                <textarea
                  type="textarea"
                  className={`form-control ${
                    errors.desc ? "is-invalid" : ""
                  }`}
                  cols="4"
                  rows="3"
                  placeholder="Enter description"
                  value={desc}
                  onChange={(e) => {
                    const val = e.target.value;
                    const filtered = val
                      .replace(/\s{2,}/g, " ");
                    setDesc(filtered);
                    setErrors((prev) => ({ ...prev, desc: "" }));
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/\s{2,}/g, " ") // Replace multiple spaces with a single space
                      .trimStart(); // Prevent leading spaces
                  }}
                />
                {errors.desc && (
                  <div className="invalid-feedback">{errors.desc}</div>
                )}
              </div>

              <div className="col-12">
                <button
                  className="btn btn-primary float-end"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Saving..." : isEditMode ? "Update" : "Add"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountFormPage;
